import {
  DOC_FEEDBACK_CATEGORIES,
  DOC_FEEDBACK_LIMITS,
  DOC_FEEDBACK_STATUSES,
  DocFeedbackCategory,
  DocFeedbackStatus,
} from './types';

/**
 * Normalizes a docs page path so the frontend and backend agree on the key
 * used for a page: strips query string, hash, `index.html`, and leading /
 * trailing / duplicate slashes.
 *
 * @public
 */
export function normalizeDocPagePath(path: string | undefined | null): string {
  if (!path) {
    return '';
  }
  return path
    .split(/[?#]/)[0]
    .split('/')
    .filter(segment => segment.length > 0)
    .filter((segment, i, all) => !(i === all.length - 1 && segment === 'index.html'))
    .join('/')
    .slice(0, DOC_FEEDBACK_LIMITS.pagePath);
}

/** @public */
export function isDocFeedbackCategory(
  value: unknown,
): value is DocFeedbackCategory {
  return (
    typeof value === 'string' &&
    (DOC_FEEDBACK_CATEGORIES as readonly string[]).includes(value)
  );
}

/** @public */
export function isDocFeedbackStatus(value: unknown): value is DocFeedbackStatus {
  return (
    typeof value === 'string' &&
    (DOC_FEEDBACK_STATUSES as readonly string[]).includes(value)
  );
}
